import axios from '../../axios';

export type ServiceResponse = {
  id: string;
  plateNumber: string;
  createDate: string;
  entryStation: string;
  exitStation: string;
  entryDate: string;
  exitDate: string;
  amount: number;
  invoiceNo: string;
};

export default async function getHgsRepository(
  startDate: Date,
  endDate: Date,
  invoiceNo?: string
): Promise<ServiceResponse[]> {
  let res = await axios.get(`${process.env.REACT_APP_BASE_URL}/fleet/hgs`, {
    params: {
      startDate: startDate.toISOString().split('T')[0],
      endDate: endDate.toISOString().split('T')[0],
      ...(invoiceNo ? { invoiceNo } : {}),
    },
  });
  return res.data;
}
